<template>
  <div id="AboutMeText3" :class="sectionClass">
    <p
      >“I’ve never read a book from start to finish. I get frustrated and bored.
      Having to read over the same page with none of the information sticking.
      Being a visual person, I see the letters as just differently shaped black
      squiggles, which is why I got into making letters of the alphabet more
      interesting for myself through my art.”</p
    >
  </div>
</template>

<script>
import { isMobile } from '@/helpers'

export default {
  computed: {
    sectionClass() {
      return {
        section: !this.isMobile(),
        sectionMobile: this.isMobile(),
      }
    },
  },
  methods: {
    isMobile,
  },
}
</script>

<style lang="scss" scoped>
.section {
  padding: 5% 0% 10%;
}

.sectionMobile {
  padding: 20% 0% 20%;
  font-size: small;
}
</style>



// WEBPACK FOOTER //
// src/components/about-me/AboutMeText3.vue